import {Injectable, SecurityContext} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {ApiService} from "../../service/api";
import {StateService} from "../../service/state";
import {Meta} from "@angular/platform-browser";

declare var $: any;

@Injectable()
export class ArticleResolver implements Resolve<any> {

    constructor(protected apiService: ApiService, protected stateService: StateService, protected meta: Meta) {
    }

    resolve(route: ActivatedRouteSnapshot): Promise<any> {
        let topScroll: any = $('fw-home .page-content').scrollTop();
        this.stateService.homeScroll = topScroll;
        return new Promise<any>((resolve) => {
            const params = route.params;
            this.apiService.call('/home/index/index', {id: +params['id']}).then(result => {
                let data = result.article;

                this.meta.updateTag({
                    property: 'description',
                    name: 'description',
                    content: data.title + ', Preis: ' + data.price + ' EUR'
                });

                this.meta.updateTag({
                    property: 'robots',
                    content: 'noimageindex'
                })
                this.stateService.setState('title', data.title);
                resolve(result);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/article/resolver.service.ts